import Image from "next/image";

const OpportunityCard = ({ opportunity }) => (
  <div className="rounded-lg py-6 px-3 text-center shadow-lg">
    <div className="flex-center mx-auto h-16 w-16 rounded-full bg-purple-800 text-purple">
      <Image
        src={`${process.env.NEXT_PUBLIC_STORAGE_URL}/content/${opportunity.picture}`}
        alt={`${opportunity.title} icon`}
        width={24}
        height={24}
      />
    </div>
    <h3 className="mt-6 text-xl font-semibold">{opportunity.title}</h3>
    <p className="mt-3 text-sm text-grey-700">{opportunity.text}</p>
  </div>
);

export default OpportunityCard;
